import { connect } from 'react-redux';
import { getAverageServicePrice, getServiceSoldCount } from '../selectors';
import ServicesSold from '../components/ServicesSold';

const ServicesSoldContainer = connect(state => ({
  averageServiceSale: getAverageServicePrice(state),
  servicesSold: getServiceSoldCount(state),
}))(ServicesSold);

export default ServicesSoldContainer;
